import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetLatestNoticesParams } from "apis/data-contracts";

export const useLatestNoticesQuery = () => {
  const query: GetLatestNoticesParams = {
    page: 0,
    size: 5,
  };

  return useQuery({
    queryKey: api.dashboard.getLatestNoticesKey(query),
    queryFn: () => api.dashboard.getLatestNotices(query),
    select: (res) => res.data.result,
  });
};
